export default function AC() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
            <g clipPath="url(#clip0_3838_31154)">
                <path
                    d="M25.875 15.75H10.125C9.50368 15.75 9 16.2537 9 16.875V20.25H27V16.875C27 16.2537 26.4963 15.75 25.875 15.75Z"
                    stroke="#707070"
                    strokeWidth="1.1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M30.9375 6.75H5.0625C4.13052 6.75 3.375 7.50552 3.375 8.4375V18.5625C3.375 19.4945 4.13052 20.25 5.0625 20.25H30.9375C31.8695 20.25 32.625 19.4945 32.625 18.5625V8.4375C32.625 7.50552 31.8695 6.75 30.9375 6.75Z"
                    stroke="#707070"
                    strokeWidth="1.1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M23.625 10.125H26.625" stroke="#707070" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M12.2625 22.5L11.3604 23.7887C10.9712 24.3447 11.0373 25.0998 11.5172 25.5797V25.5797C12.0094 26.0719 12.0648 26.8511 11.6472 27.4079L10.6875 28.6875"
                    stroke="#707070"
                    strokeWidth="1.1"
                    strokeLinecap="round"
                />
                <path
                    d="M18.45 22.5L17.5479 23.7887C17.1587 24.3447 17.2248 25.0998 17.7047 25.5797V25.5797C18.1969 26.0719 18.2523 26.8511 17.8347 27.4079L16.875 28.6875"
                    stroke="#707070"
                    strokeWidth="1.1"
                    strokeLinecap="round"
                />
                <path
                    d="M24.6375 22.5L23.7354 23.7887C23.3462 24.3447 23.4123 25.0998 23.8922 25.5797V25.5797C24.3844 26.0719 24.4398 26.8511 24.0222 27.4079L23.0625 28.6875"
                    stroke="#707070"
                    strokeWidth="1.1"
                    strokeLinecap="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_3838_31154">
                    <rect width="36" height="36" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
